/** @jsxImportSource @emotion/react */

import { useQuery } from "@tanstack/react-query";
import { useGetProfile } from "api/user/query";
import { PATH } from "constants/path";
import { QueryKeys } from "constants/queryKeys";
import { useAppContext } from "contexts/app.context";
import { ModalTypeValue } from "enums/modalType";
import { handleLogout } from "helpers/handleLogout";
import { handleOpenModal } from "helpers/handleModal";
import { handleNewWindow } from "helpers/handleNewWindow";

import GameMenu from "./GameMenu";
import { HeaderStyle } from "./index.style";
import TopTime from "./TopTime";

export const Header = () => {
    // const isAuthenticated = useQuery<boolean>([QueryKeys.isAuthenticated]);
  const { data: username } = useQuery<string>([QueryKeys.username]);
  const { data: info } = useGetProfile(username as string, !!username);
  const { state, dispatch } = useAppContext();

  return (
    <div css={HeaderStyle.index("ct")}>
      <div css={HeaderStyle.content}>
        <div css={HeaderStyle.topTime}>
          <TopTime />
        </div>
        {!username ? (
          <div css={HeaderStyle.loginArea("ct")}>
            <div
              className="btn_login"
              onClick={() =>
                handleOpenModal(state, dispatch, ModalTypeValue.LOGIN)
              }
            >
              {"登入"}
            </div>
            <div
              className="btn_addMember"
              onClick={() =>
                handleOpenModal(state, dispatch, ModalTypeValue.REGISTER)
              }
            >
              {"註冊"}
            </div>
            {/* <div className="changeLanguage">
              <ChangeLanguage />
            </div> */}
          </div>
        ) : (
          <div css={HeaderStyle.memberArea("ct")}>
            <ul>
              <li className="memberAC">
                <span className="ng-binding">{info?.username}</span>
                <span className="memberNick">
                  <span className="ng-binding">{info?.full_name}</span>
                </span>
              </li>
              <GameMenu />
              <li>
                <span className="memberFlow ng-scope">
                  <span
                    className="btn_RoundTextY"
                    onClick={() =>
                      handleNewWindow(PATH.User.Deposit, 1200, 700)
                    }
                  >
                    {"存款"}
                  </span>
                </span>
              </li>
              <li>
                <span className="memberFlow ng-scope">
                  <span
                    className="btn_RoundTextZ"
                    onClick={() =>
                      handleNewWindow(PATH.User.Withdraw, 1200, 700)
                    }
                  >
                    {"提款"}
                  </span>
                </span>
              </li>

              <li>
                <span className="memberCtrl">
                  <span
                    className="btn_member"
                    onClick={() =>
                      handleNewWindow(PATH.User.Profile, 1200, 700)
                    }
                  ></span>
                  <div className="RoundText_prompt">
                    <div className="RT_promptText">{"會員中心"}</div>
                  </div>
                </span>
              </li>
              <li>
                <span className="memberCtrl">
                  <span
                    className="btn_personalMsg"
                    onClick={() =>
                      handleNewWindow(PATH.PersonalMessage, 1200, 700)
                    }
                  ></span>
                  <div className="RoundText_prompt">
                    <div className="RT_promptText">
                      {"公告"}
                    </div>
                  </div>
                </span>
              </li>
              <li onClick={handleLogout}>
                <span className="memberCtrl">
                  <span className="btn_signout"></span>
                  <div className="RoundText_prompt">
                    <div className="RT_promptText">{"登出"}</div>
                  </div>
                </span>
              </li>
            </ul>
            {/* <div className="changeLanguage">
              <ChangeLanguage />
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};
